import "./App.css";
import { useEffect } from "react";
import Login from "./componets/Login/Login";
import Dashboard from "./componets/Dashboard/Dashboard";
import Driveanalysis from "./componets/Dashboard/Driveanalysis/Driveanalysis";
// import LandingPage from './componets'
import moment from "moment";
import { Routes, Route, Navigate } from "react-router-dom";
import HomePage from "./componets/Dashboard/HomePage/HomePage";
import VehicleInsights from "./componets/Dashboard/VehicleInsights/VehicleInsights";
import GlossaryPage from "./componets/Dashboard/Driveanalysis/GlossaryPage";
import GlossaryPage_Erc from "./componets/Dashboard/Driveanalysis/GlossaryPage_Erc";
import PPTPage from "./componets/Dashboard/Driveanalysis/PPTPage";
import Auth from "./store/Auth";
import NoAuth from "./store/NoAuth";
import Action from "./util/Action";
import Faultanalysis from "./componets/Dashboard/Faultanalysis/FaultanalysisSecond";
import FaultPage from "./componets/Dashboard/Faultanalysis/FaultPage";
import GlossaryPageFaultanalysis from "./componets/Dashboard/Faultanalysis/GlossaryPageFaultanalysis";
import PPTPageFaultanalysis from "./componets/Dashboard/Faultanalysis/PPTPageFaultanalysis";
import GlossaryPageCharginganalysis from "./componets/Dashboard/Charginganalysis/ChargingFirstPage/GlossaryPageCharginganalysis";
import Realtime from "./componets/Dashboard/Realtime/Realtime";
import MileageSaarathi_bus from "./componets/Dashboard_Bus/Mileagesaarathi_bus/MileageSaarathi_bus";
// import Overview_ace from "./componets/Dashboard/MileagesarthiAce/Overview_ace";
import MileageSaarathi_ace from "./componets/Dashboard/MileageSaarathiAce/MileageSaarathi_ace";

import VehicleInsights_Bus from "./componets/Dashboard_Bus/VehicleInsights_Bus/VehicleInsights_Bus";
import Driveanalysis_Bus from "./componets/Dashboard_Bus/Driveanalysis_Bus/Driveanalysis_Bus";
import ChargingPage from "./componets/Dashboard/Charginganalysis/ChargingPage";
import PPTPageCharginganalysis from "./componets/Dashboard/Charginganalysis/ChargingFirstPage/PPTPageCharginganalysis";
import WorkBench from "./componets/Dashboard/WorkBench";
import Ais from "./componets/Dashboard/Ais/Ais";
import Arai from "./componets/Dashboard/Ais/Arai";
import GlossaryPage_Bus from "./componets/Dashboard_Bus/Driveanalysis_Bus/GlossaryPage_Bus";
import PPTPage_Bus from "./componets/Dashboard_Bus/Driveanalysis_Bus/PPTPage_Bus";

// fault analysis bus
import GlossaryPage_Fault_Bus from "./componets/Dashboard_Bus/Faultanalysis_Bus/GlossaryPage_Fault_Bus";
import PPTPage_Fault_Bus from "./componets/Dashboard_Bus/Faultanalysis_Bus/PPTPage_Fault_Bus";
// fault analysis bus

import RcaNew from "./componets/Dashboard_Bus/Rca_Bus/RcaNew";
import FaultPage_Bus from "./componets/Dashboard_Bus/Faultanalysis_Bus/FaultPage_Bus";
import Charging_Bus from "./componets/Dashboard_Bus/Charginganalysis_Bus/ChargingPage_Bus";

import ACERcaNew from "./componets/Dashboard/Rca_Ace/ACERcaNew";
import GlossaryPage_Charging_Bus from "./componets/Dashboard_Bus/Charginganalysis_Bus/GlossaryPage_Charging_Bus";
import PPTPage_Charging_Bus from "./componets/Dashboard_Bus/Charginganalysis_Bus/PPTPage_Charging_Bus";

import FaultPage_BusNew from "./componets/Dashboard_Bus/Faultanalysis_BusNew/FaultPage_BusNew";
import TrendAnalysisMainBus from "./componets/Dashboard_Bus/TrendAnalysis_Bus/TrendAnalysisMainBus";
import BatteryDigitalTwinTest from "./componets/Dashboard_Bus/BatteryDigitalTwin_Bus/BatteryDigitalTwinTest";
import Critical_vehicles_Bus from "./componets/Dashboard_Bus/CriticalVehicles_Bus/Critical_vehicles_Bus";
import Critical_vehicles_Bus_fleet from "./componets/Dashboard_Bus/CriticalVehicle_Bus_Fleet/Critical_vehicles_Bus_fleet";
import PPTPage_Trend_Bus from "./componets/Dashboard_Bus/TrendAnalysis_Bus/PPTPage_Trend_Bus";

import Energyanalysis_Bus from "./componets/Dashboard_Bus/Energyanalysis_Bus/Energyanalysis_Bus";
import GlossaryPage_Energy_Bus from "./componets/Dashboard_Bus/Energyanalysis_Bus/GlossaryPage_Energy_Bus";
import PPTPage_Energy_Bus from "./componets/Dashboard_Bus/Energyanalysis_Bus/PPTPage_Energy_Bus";
import PdfPage_Bus from "./componets/Dashboard_Bus/PDFDownload_Bus/PdfPage_Bus";
import DigitalInstrumentCluster from "./componets/Dashboard/DigitalInstrumentCluster/DigitalInstrumentCluster";
import PPTPageDIC from "./componets/Dashboard/DigitalInstrumentCluster/PPTPageDIC";

import EnergyBillReconcilliation_Bus from "./componets/Dashboard_Bus/EnergyBillReconcilliation_Bus/EnergyBillReconcilliation_Bus";
import BDT_HomePage_Bus from "./componets/Dashboard_Bus/BatteryDigitalTwin_Bus/BDT_HomePage_Bus";
import RangePolygon from "./componets/Dashboard/RangePolygon/RangePolygon";

import VehicleInsights_Orion from "./componets/Dashboard_Orion/VehicleInsights_Orion/VehicleInsights_Orion";
import Driveanalysis_Orion from "./componets/Dashboard_Orion/Driveanalysis_Orion/Driveanalysis_Orion";
import Critical_vehicles_Orion from './componets/Dashboard_Orion/CriticalVehicles_Orion_ERC/Critical_vehicles_Orion';
import Critical_vehicles_Orion_fleet from "./componets/Dashboard_Orion/CriticalVehicle_Orion_Ascent/Critical_vehicles_Orion_fleet";
import Charging_Orion from "./componets/Dashboard_Orion/Charginganalysis_Orion/ChargingPage_Orion";
import Energyanalysis_Orion from "./componets/Dashboard_Orion/Energyanalysis_Orion/Energyanalysis_Orion";
import FaultPage_Orion from "./componets/Dashboard_Orion/Faultanalysis_Orion/FaultPage_Orion";
// import GlossaryPageDrive_Orion from "./componets/Dashboard_Orion/Driveanalysis_Orion/GlossaryPageDrive_Orion";
// import PPTPageDrive_Orion from "./componets/Dashboard_Orion/Driveanalysis_Orion/PPTPageDrive_Orion";
// import GlossaryPage_Charging_Orion from "./componets/Dashboard_Orion/Charginganalysis_Orion/GlossaryPage_Charging_Orion";
// import PPTPage_Charging_Orion from "./componets/Dashboard_Orion/Charginganalysis_Orion/PPTPage_Charging_Orion";
// import GlossaryPage_Energy_Orion from "./componets/Dashboard_Orion/Energyanalysis_Orion/GlossaryPage_Energy_Orion";
// import PPTPage_Energy_Orion from "./componets/Dashboard_Orion/Energyanalysis_Orion/PPTPage_Energy_Orion";

import VehicleInsights_Kratos from "./componets/Dashboard_Kratos/VehicleInsights_Kratos/VehicleInsights_Kratos";
import Driveanalysis_Kratos from "./componets/Dashboard_Kratos/Driveanalysis_Kratos/Driveanalysis_Kratos";
import Charging_Kratos from "./componets/Dashboard_Kratos/Charginganalysis_Kratos/ChargingPage_Kratos";
import Critical_vehicles_Kratos from "./componets/Dashboard_Kratos/CriticalVehicles_Kratos/Critical_vehicles_Kratos";
import Energyanalysis_Kratos from "./componets/Dashboard_Kratos/Energyanalysis_Kratos/Energyanalysis_Kratos";
import Critical_vehicles_Kratos_fleet from "./componets/Dashboard_Kratos/CriticalVehicle_Kratos_Fleet/Critical_vehicles_Kratos_fleet";
import FaultPage_BusNew1 from "./componets/Dashboard_Kratos/Faultanalysis_BusNew/FaultPage_BusNew";
// import GlossaryPageDrive_Kratos from "./componets/Dashboard_Kratos/Driveanalysis_Kratos/GlossaryPageDrive_Kratos";
// import PPTPageDrive_Kratos from "./componets/Dashboard_Kratos/Driveanalysis_Kratos/PPTPageDrive_Kratos";
// import GlossaryPage_Charging_Kratos from "./componets/Dashboard_Kratos/Charginganalysis_Kratos/GlossaryPage_Charging_Kratos";
// import PPTPage_Charging_Kratos from "./componets/Dashboard_Kratos/Charginganalysis_Kratos/PPTPage_Charging_Kratos";
// import GlossaryPage_Energy_Kratos from "./componets/Dashboard_Kratos/Energyanalysis_Kratos/GlossaryPage_Energy_Kratos";
// import PPTPage_Energy_Kratos from "./componets/Dashboard_Kratos/Energyanalysis_Kratos/PPTPage_Energy_Kratos";


import Driveanalysis_Coral from "./componets/Dashboard_Coral/Driveanalysis_Coral/Driveanalysis_Coral";
import VehicleInsights_Coral from "./componets/Dashboard_Coral/VehicleInsights_Coral/Vehicleinsights_Coral";
import { Component } from "lucide-react";
import HomePage_Coral from "./componets/Dashboard_Coral/HomePage_Coral/HomePage_Coral";
import Faultanalysis_Coral from "./componets/Dashboard_Coral/Faultanalysis_Coral/FaultanalysisSecond_Coral";
import FaultPage_Coral from "./componets/Dashboard_Coral/Faultanalysis_Coral/FaultPage_Coral";
import GlossaryPageFaultanalysis_Coral from "./componets/Dashboard_Coral/Faultanalysis_Coral/GlossaryPageFaultanalysis_Coral";
import PPTPageFaultanalysis_Coral from "./componets/Dashboard_Coral/Faultanalysis_Coral/PPTPageFaultanalysis_Coral";
// import AccessControlledRoute from "./AccessControlledRoute";
import NotFound from "./NotFound";
import GlossaryPage_Coral from "./componets/Dashboard_Coral/Driveanalysis_Coral/GlossaryPage_Coral";
import GlossaryPage_Erc_Coral from "./componets/Dashboard_Coral/Driveanalysis_Coral/GlossaryPage_Erc";
import PPTPage_Coral from "./componets/Dashboard_Coral/Driveanalysis_Coral/PPTPage_Coral";
import Realtime_Coral from "./componets/Dashboard_Coral/Realtime_Coral/Realtime_Coral";
import DigitalInstrumentCluster_Coral from "./componets/Dashboard_Coral/DigitalInstrumentCluster_Coral/DigitalInstrumentCluster_Coral";
import PPTPageDIC_Coral from "./componets/Dashboard_Coral/DigitalInstrumentCluster_Coral/PPTPageDIC_Coral";


import LandingPage from "./componets/Login/LandingPage";
import Pdl from './componets/Dashboard_Summary/Components/Pdl';
import LayoutMain from "./componets/Dashboard_Summary/DashboardMain/LayoutMain";

import Driveanalysis_Jupiter from "./componets/Dashboard_Jupiter/Driveanalysis_Jupiter/Driveanalysis_Jupiter";
import VehicleInsights_Jupiter from "./componets/Dashboard_Jupiter/VehicleInsights_Jupiter/Vehicleinsights_Jupiter";
import HomePage_Jupiter from "./componets/Dashboard_Jupiter/HomePage_Jupiter/HomePage_Jupiter";
import RealtimeJupiter from "./componets/Dashboard_Jupiter/Realtime_Jupiter/RealtimeJupiter";
import DigitalInstrumentClusterJupiter from "./componets/Dashboard_Jupiter/DigitalInstrumentCluster_Jupiter/DigitalInstrumentClusterJupiter"
import PPTPageDIC_Jupiter from "./componets/Dashboard_Jupiter/DigitalInstrumentCluster_Jupiter/PPTPageDIC";
import usePageTimeTracker from "./hook/usePageTimeTracker";
import ChargingPage_Jupiter from "./componets/Dashboard_Jupiter/Charginganalysis_Jupiter/ChargingPage_Jupiter";
import DisplayPPTPage from "./componets/Shared/DisplayPPTPage";
import NavigationGuidePDF from "./componets/Login/navigationGuide.pdf"
import UsersSearchingPage from "./componets/UsersHeadquarter/UsersSearchingPage";
import PDLHomePage from "./componets/Dashboard_Bus/SmartCIty/PDL/PDLHomePage";
import TCUHomePage from "./componets/Dashboard_Bus/SmartCIty/TCU/TCUHomePage";

function App({ keycloak }) {

  // usePageTimeTracker({
  //   apiUrl:""
  //    
  //   syncInterval: 10000,
  //   idleTimeout: 300000,
  // });

  return (
    <div className="App">
      <Action />
      <Routes>

        {/* <Route element={<NoAuth />}>
  
            <Route path="/login" element={<Login />} />
  
          </Route> */}

        <Route element={<Auth keycloak={keycloak} />}>
          <Route path="/" element={<LandingPage keycloak={keycloak} />} />
          <Route path="/login" element={<Navigate to="/" />} />
          <Route path="/unauthorized" element={<NotFound />} />
          <Route path="dashboard/faultanalysis_second" element={<Faultanalysis />} />
          <Route path="/homePage" element={<HomePage />} />
          <Route path="vehicleinsights" element={<VehicleInsights />} />
          <Route path="dashboard/faultanalysis" element={<FaultPage />} />
          <Route path="dashboard/driveanalysis" element={<Driveanalysis />} />
          <Route path="dashboard/glossarypage" element={<GlossaryPage />} />
          <Route path="dashboard/glossarypage_drive_erc" element={<GlossaryPage_Erc />} />
          <Route path="dashboard/navigation_guide" element={<PPTPage />} />
          <Route path="dashboard/glossarypagefaultanalysis" element={<GlossaryPageFaultanalysis />} />
          <Route path="dashboard/navigation_guide_fault" element={<PPTPageFaultanalysis />} />

          <Route path="vehicleinsights_bus" element={<VehicleInsights_Bus />} />
          <Route path="dashboard_bus/driveanalysis_bus" element={
            // <AccessControlledRoute allowed={["1"]}>
            <Driveanalysis_Bus />
            // </AccessControlledRoute>
          } />
          <Route path="dashboard/charginganalysis" element={
            // <AccessControlledRoute allowed={["4"]}>
            <ChargingPage />
            // </AccessControlledRoute>
          } />
          <Route path="dashboard/glossarypagecharginganalysis" element={<GlossaryPageCharginganalysis />} />
          <Route path="dashboard/navigation_guide_charging" element={<PPTPageCharginganalysis />} />
          <Route path="workbench" element={<WorkBench />} />
          <Route path="dashboard_bus/glossarypage_bus" element={<GlossaryPage_Bus />} />
          <Route path="dashboard_bus/navigationguide_bus" element={<PPTPage_Bus />} />
          <Route path="arai/ais" element={<Ais />} />
          <Route path="arai" element={<Arai />} />

          <Route path="dashboard_bus/rca_bus" element={
            // <AccessControlledRoute allowed={["3"]}>
            <RcaNew />
            // </AccessControlledRoute>
          } />

          <Route path="dashboard_bus/GlossaryPage_Fault_Bus" element={<GlossaryPage_Fault_Bus />} />
          <Route path="dashboard_bus/navigationguide_fault_bus" element={<PPTPage_Fault_Bus />} />

          <Route path="dashboard_bus/charginganalysis_bus" element={
            // <AccessControlledRoute allowed={["4"]}>
            <Charging_Bus />
            // </AccessControlledRoute>
          } />
          <Route path="dashboard_bus/GlossaryPage_Charging_Bus" element={<GlossaryPage_Charging_Bus />} />
          <Route path="dashboard_bus/navigationguide_Charging_bus" element={<PPTPage_Charging_Bus />} />
          <Route path="dashboard_bus/rca_bus/:chasis" element={
            // <AccessControlledRoute allowed={["3"]}>
            <RcaNew />
            // </AccessControlledRoute>
          } />

          <Route path="dashboard/rca" element={<ACERcaNew />} />
          <Route path="dashboard/rca/:chasis" element={<ACERcaNew />} />

          <Route path="dashboard_bus/faultanalysis_bus" element={
            // <AccessControlledRoute allowed={["2"]}>
            <FaultPage_BusNew />
            // </AccessControlledRoute>
          } />
          <Route path="dashboard_bus/trendanalysis_bus" element={
            // <AccessControlledRoute allowed={["7"]}>
            <TrendAnalysisMainBus />
            // </AccessControlledRoute>
          } />
          <Route path="dashboard_bus/navigationguide_trend_bus" element={<PPTPage_Trend_Bus />} />

          <Route path="dashboard_bus/bdt" element={<BatteryDigitalTwinTest />} />
          <Route path="dashboard_bus/criticalvehicles_bus" element={
            // <AccessControlledRoute allowed={["10"]}>
            <Critical_vehicles_Bus />
            // </AccessControlledRoute>
          } />
          <Route path="dashboard_bus/criticalvehicles_bus_fleet" element={
            // <AccessControlledRoute allowed={["11"]}>
            <Critical_vehicles_Bus_fleet />
            // </AccessControlledRoute>
          } />

          {/* routes for energy analysis bus */}
          <Route path="dashboard_bus/energyanalysis_bus" element={
            // <AccessControlledRoute allowed={["12"]}>
            <Energyanalysis_Bus />
            // </AccessControlledRoute>
          } />
          <Route path="dashboard_bus/GlossaryPage_Energy_Bus" element={<GlossaryPage_Energy_Bus />} />
          <Route path="dashboard_bus/navigationguide_Energy_Bus" element={<PPTPage_Energy_Bus />} />
          <Route path="dashboard_bus/PdfFirstPage" element={
            // <AccessControlledRoute allowed={["13"]}>
            <PdfPage_Bus />
            // </AccessControlledRoute>
          } />
          {/* routes for energy analysis bus */}

          {/* routes for mileage saarathi cesl */}
          <Route path="/MileageSaarathi_bus" element={
            // <AccessControlledRoute allowed={["19"]}>
            <MileageSaarathi_bus />
            // </AccessControlledRoute>

          } />
          <Route path="/MileageSaarathi_Ace" element={<MileageSaarathi_ace />} />
          {/* routes for mileagesaarathi */}

          {/* real time dashboard */}
          <Route path="realtime" element={<Realtime />} />
          <Route path="realtime/digitalinstrumentcluster" element={<DigitalInstrumentCluster />} />
          <Route path="realtime/navigation_guide_dic" element={<PPTPageDIC />} />
          {/* real time dashboard */}

          {/* Energy Bill Reconcilliation_Bus */}
          <Route path="dashboard_bus/energybillreconcilliation_bus" element={
            // <AccessControlledRoute allowed={["16"]}>
            <EnergyBillReconcilliation_Bus />
            // </AccessControlledRoute>
          } />
          {/* Energy Bill Reconcilliation_Bus */}

          {/*  battery digital twin  */}
          <Route path="dashboard_bus/battery_digital_twin" element={
            // <AccessControlledRoute allowed={["17"]}>
            <BDT_HomePage_Bus />
            // </AccessControlledRoute>
          } />
          {/*  battery digital twing  */}

          {/* range polygon */}
          <Route path="realtime/rangepolygon" element={<RangePolygon />} />
          {/* range polygon */}

          {/* routes for orion */}
          <Route path="vehicleInsights_orion" element={<VehicleInsights_Orion />} />
          <Route path="dashboard_orion/driveanalysis_orion" element={<Driveanalysis_Orion />} />
          <Route path="dashboard_orion/criticalvehicles_orion" element={<Critical_vehicles_Orion />} />
          <Route path="dashboard_orion/criticalvehicles_orion_ascent" element={<Critical_vehicles_Orion_fleet />} />
          <Route path="dashboard_orion/charginganalysis_orion" element={<Charging_Orion />} />
          <Route path="dashboard_orion/energyanalysis_orion" element={<Energyanalysis_Orion />} />
          {/* <Route path="dashboard_Orion/GlossaryPage_Energy_Orion" element={<GlossaryPage_Energy_Orion />} />
          <Route path="dashboard_Orion/navigationguide_Energy_Orion" element={<PPTPage_Energy_Orion />} />
          <Route path="dashboard_orion/GlossaryPage_Charging_orion" element={<GlossaryPage_Charging_Orion />} />
          <Route path="dashboard_orion/navigationguide_Charging_orion" element={<PPTPage_Charging_Orion />} /> */}
          {/* routes for orion */}

          {/* routes for kratos */}
          <Route path="vehicleInsights_kratos" element={<VehicleInsights_Kratos />} />
          <Route path="dashboard_kratos/driveanalysis_kratos" element={<Driveanalysis_Kratos />} />
          <Route path="dashboard_kratos/charginganalysis_kratos" element={<Charging_Kratos />} />
          <Route path="dashboard_kratos/criticalvehicles_kratos" element={<Critical_vehicles_Kratos />} />
          <Route path="dashboard_kratos/criticalvehicles_kratos_ascent" element={<Critical_vehicles_Kratos_fleet />} />
          <Route path="dashboard_kratos/energyanalysis_kratos" element={<Energyanalysis_Kratos />} />
          <Route path="dashboard_kratos/faultanalysis_kratos" element={<FaultPage_BusNew1 />} />
          {/* <Route path="dashboard_kratos/glossarypage_kratos" element={<GlossaryPageDrive_Kratos />} />
          <Route path="dashboard_kratos/navigationguide_kratos" element={<PPTPageDrive_Kratos />} /> */}
          {/* <Route path="dashboard_kratos/GlossaryPage_Charging_kratos" element={<GlossaryPage_Charging_Kratos />} /> */}
          {/* <Route path="dashboard_kratos/navigationguide_Charging_kratos" element={<PPTPage_Charging_Kratos />} /> */}
          {/* <Route path="dashboard_Kratos/GlossaryPage_Energy_Kratos" element={<GlossaryPage_Energy_Kratos />} /> */}
          {/* <Route path="dashboard_Kratos/navigationguide_Energy_Kratos" element={<PPTPage_Energy_Kratos />} /> */}
          {/* routes for kratos */}

          {/*routes for coral */}
          <Route path="dashboard_coral" element={<HomePage_Coral />} />
          <Route path='VehicleInsights_Coral' element={<VehicleInsights_Coral />} />
          <Route path='Driveanalysis_Coral' element={<Driveanalysis_Coral />} />
          <Route path='VehicleInsights_Coral/Faultanalysis_Coral' element={<Faultanalysis_Coral />} />
          <Route path='faultanalysis_coral' element={<FaultPage_Coral />} />
          <Route path='glossarypagefaultanalysis' element={<GlossaryPageFaultanalysis_Coral />} />
          <Route path='navigation_guide_fault' element={<PPTPageFaultanalysis_Coral />} />
          {/* <Route path="dashboard/glossarypage_coral" element={<GlossaryPage_Coral />} /> */}
          <Route path="dashboard/glossarypage_drive_coral_erc" element={<GlossaryPage_Erc_Coral />} />
          <Route path='dashboard/glossarypagefaultanalysis_Coral' element={<GlossaryPageFaultanalysis_Coral />} />
          <Route path="dashboard/navigation_guide_Coral" element={<PPTPage_Coral />} />
          <Route path="dashboard/navigation_guide_fault_Coral" element={<PPTPageFaultanalysis_Coral />} />
          <Route path="realtime_coral" element={<Realtime_Coral />} />
          <Route path="realtime_coral/digitalinstrumentcluster_coral" element={<DigitalInstrumentCluster_Coral />} />
          <Route path="realtime_coral/navigation_guide_dic_coral" element={<PPTPageDIC_Coral />} />
          <Route path="/dashboard_orion/faultanalysis_orion" element={< FaultPage_Orion />} />
          {/*routes for coral */}

          {/*routes for jupiter */}
          <Route path='dashboard_jupiter' element={<HomePage_Jupiter />} />
          <Route path='VehicleInsights_Jupiter' element={<VehicleInsights_Jupiter />} />
          <Route path='Driveanalysis_Jupiter' element={<Driveanalysis_Jupiter />} />
          <Route path='realtime_jupiter' element={<RealtimeJupiter />} />
          <Route path="realtime_jupiter/digitalinstrumentcluster_jupiter" element={<DigitalInstrumentClusterJupiter />} />
          <Route path="realtime_jupiter/navigation_guide_dic_jupiter" element={<PPTPageDIC_Jupiter />} />
          <Route path="dashboard_jupiter/charginganalysis_Jupiter" element={<ChargingPage_Jupiter />} />
          {/*routes for jupiter */}

          <Route path="/summary/pdl" element={<Pdl />} />
          <Route path="/daily-metrics" element={<LayoutMain />}>
            <Route path="summary/pdl" element={<Pdl />} />
          </Route>
          <Route path="/dashboard_bus/PDL" element={<PDLHomePage/>}/>
          <Route path="/dashboard_bus/tcu" element={<TCUHomePage/>}/>
          <Route path="guide-book" element={<DisplayPPTPage heading={"Navigation Guide"} pdf={NavigationGuidePDF} />} />

        </Route>
        {/*Users headquater Start*/}
        <Route path="search-users" element={<UsersSearchingPage />} />
        {/*Users headquater End*/}
      </Routes>
    </div>
  );
}

export default App;
